import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-dream-surface border-t border-dream-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/w4q79k1x_Dream%20Maker-4.png" 
                alt="Dream Makers Recording Group"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-sm text-white/60 mb-4">
              Melbourne's premium creative studio for artists, producers, and dreamers.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-white/60 hover:text-dream-violet transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/60 hover:text-dream-violet transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: "Services", path: "/services" },
                { name: "Pricing", path: "/pricing" },
                { name: "Gallery", path: "/gallery" },
                { name: "DJ Lessons", path: "/lessons" },
                { name: "About", path: "/about" },
                { name: "Contact", path: "/contact" }
              ].map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.path}
                    className="text-sm text-white/60 hover:text-dream-violet transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Recording Studio</li>
              <li>Mixing & Mastering</li>
              <li>Production Suite</li>
              <li>Dream Makers Sessions</li>
              <li>Photography Studio</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm">
                <Phone className="w-4 h-4 mt-0.5 text-dream-violet flex-shrink-0" />
                <div className="text-white/60">
                  <a href="tel:0421815593" className="hover:text-dream-violet transition-colors block">
                    0421 815 593
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="w-4 h-4 text-dream-violet flex-shrink-0" />
                <a href="mailto:dreammakersrecordinggroup@gmail.com" className="text-white/60 hover:text-dream-violet transition-colors">
                  dreammakersrecordinggroup@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dream-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/40">
            © {new Date().getFullYear()} Dream Makers Recording Group. All rights reserved.
          </p>
          <p className="text-sm text-white/40">
            Est. 2024 | Tullamarine, Melbourne
          </p>
        </div>
      </div>
    </footer>
  );
}
